import { render, staticRenderFns } from "./ManageTagsAndCustomDataFields.vue?vue&type=template&id=22201d2c"
import script from "./ManageTagsAndCustomDataFields.vue?vue&type=script&lang=js"
export * from "./ManageTagsAndCustomDataFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports